
import React from "react";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";

interface VideoEditorProps {
  content: any;
  onContentChange: (field: string, value: any) => void;
}

const VideoEditor: React.FC<VideoEditorProps> = ({ content, onContentChange }) => {
  // Initialize content with default values if not provided
  const videoContent = {
    url: "",
    autoplay: false,
    muted: true,
    controls: true,
    loop: false,
    aspect: "16:9",
    ...content
  };

  const handleContentChange = (field: string, value: any) => {
    onContentChange(field, value);
  };

  return (
    <div className="space-y-6">
      <div>
        <label className="block mb-2">כתובת URL של הוידאו</label>
        <Input
          value={videoContent.url}
          onChange={(e) => handleContentChange("url", e.target.value)}
          placeholder="https://example.com/video.mp4"
        />
        <p className="text-sm text-gray-500 mt-1">
          ניתן להזין קישורים ישירים לקבצי וידאו (mp4, webm) או כתובות YouTube, Vimeo
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Label htmlFor="aspect-ratio">יחס תצוגה</Label>
          <Select 
            value={videoContent.aspect} 
            onValueChange={(value) => handleContentChange("aspect", value)}
          >
            <SelectTrigger id="aspect-ratio">
              <SelectValue placeholder="יחס תצוגה" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="16:9">16:9 (רוחב מסך)</SelectItem>
              <SelectItem value="4:3">4:3 (קלאסי)</SelectItem>
              <SelectItem value="1:1">1:1 (ריבוע)</SelectItem>
              <SelectItem value="9:16">9:16 (אנכי)</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="flex items-center justify-between">
          <div className="space-y-0.5">
            <Label htmlFor="autoplay">הפעלה אוטומטית</Label>
            <p className="text-sm text-gray-500">הוידאו יופעל אוטומטית כשהדף נטען</p>
          </div>
          <Switch
            id="autoplay"
            checked={videoContent.autoplay}
            onCheckedChange={(checked) => handleContentChange("autoplay", checked)}
          />
        </div>

        <div className="flex items-center justify-between">
          <div className="space-y-0.5">
            <Label htmlFor="muted">השתק</Label>
            <p className="text-sm text-gray-500">הוידאו יופעל ללא קול</p>
          </div>
          <Switch
            id="muted"
            checked={videoContent.muted}
            onCheckedChange={(checked) => handleContentChange("muted", checked)}
          />
        </div>

        <div className="flex items-center justify-between">
          <div className="space-y-0.5">
            <Label htmlFor="controls">שליטה</Label>
            <p className="text-sm text-gray-500">הצג כפתורי שליטה בנגן</p>
          </div>
          <Switch
            id="controls"
            checked={videoContent.controls}
            onCheckedChange={(checked) => handleContentChange("controls", checked)}
          />
        </div>

        <div className="flex items-center justify-between">
          <div className="space-y-0.5">
            <Label htmlFor="loop">חזרה</Label>
            <p className="text-sm text-gray-500">הוידאו יחזור על עצמו ברצף</p>
          </div>
          <Switch
            id="loop"
            checked={videoContent.loop}
            onCheckedChange={(checked) => handleContentChange("loop", checked)}
          />
        </div>
      </div>
    </div>
  );
};

export default VideoEditor;
